export default "__VITE_ASSET__B9AbvWX5__"